<template>
  <section>
    <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px">
      <el-form-item label="项目"  prop="proId">
        <el-select v-model="formObj.proId" placeholder="请选择项目">
          <el-option v-for="(item,index) in GLOBAL.proList" :key="item.id" :value="item.id"
                     :label="item.proName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="mesTitle">
        <el-input v-model="formObj.mesTitle" placeholder="请输入标题" maxlength="20"  show-word-limit></el-input>
      </el-form-item>

      <div class="hello" style="width: 90%;margin: auto;padding-left: 90px;">
        <div id="editor" type="text/plain"></div>
      </div>
      <el-form-item label="" prop="mesContent" ></el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import {mesCreate, mesUpdate,proSearch} from '../../api/api'
  import "../../../static/ueditor/ueditor.config.js";
  import "../../../static/ueditor/ueditor.all.js";
  import "../../../static/ueditor/lang/zh-cn/zh-cn.js";
  import "../../../static/ueditor/ueditor.parse.js";

  export default {
    name: "EnclosureDataForm",
    props: {
      option: 0,
      formObj: {proId:null,title:null,content:null},
      type: 0,

    },
    data() {
      return {
        formRules: {
          proId: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          mesTitle: [
            {required: true, message: '请输入标题', trigger: 'blur'}
          ],
          mesContent: [
            {required: true, message: '请输入内容', trigger: 'blur'}
          ],
        },
        time:null,
        proList:[],
      }
    },
    methods: {
      doSubmit: function (option) {
        let c = UE.getEditor('editor').getContent();
        this.formObj.mesContent = c;
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              if (option == 0) {
                mesCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              } else if (option == 1) {
                mesUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
      initUE:function(){
        UE.getEditor("editor").setContent(this.formObj.mesContent);
        clearInterval(this.time);
      }
  },
    mounted() {
      //初始化数据
      //初始化表单数据
      this.ue = UE.getEditor("editor");
      if(this.option==1)
      {
        this.time = setInterval(this.initUE,200);
      }
    },destroyed() {
      UE.getEditor('editor').destroy();
      if(this.option==1)
      {
        clearInterval(this.time);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/message/MessageForm.vue